import { gql } from 'graphql-request';

export const getRandomSentences = gql`
  query GetRandomSentences(
    $level: Int
    $number: Int = 1
    $notSent: [Int!]
    $sentence: String
    $skill: Int
  ) {
    getRandomSentences(
      level: $level
      number: $number
      notSent: $notSent
      sentence: $sentence
      skill: $skill
    ) {
      id
      chinese
      traditional
      simplified
      pinyinNumbers
      pinyinMarks
      level
      cmnTatoebaId
      engTatoebaId
      english
    }
  }
`;

export const getSentence = gql`
  query GetSentence($id: Int!) {
    getSentence(id: $id) {
      id
      chinese
      traditional
      simplified
      pinyinNumbers
      pinyinMarks
      level
      cmnTatoebaId
      engTatoebaId
      english
    }
  }
`;

export const getSentences = gql`
  query GetSentences(
    $page: Int = 1
    $pageSize: Int = 20
    $level: Int
    $ordering: String
  ) {
    getSentences(
      page: $page
      pageSize: $pageSize
      level: $level
      ordering: $ordering
    ) {
      count
      next
      previous
      results {
        id
        chinese
        traditional
        simplified
        pinyinNumbers
        pinyinMarks
        level
        cmnTatoebaId
        engTatoebaId
        english
      }
      totalPages
    }
  }
`;

export const saveSentence = gql`
  mutation SaveSentence($userId: Int!, $sentenceId: Int!) {
    saveSentence(userId: $userId, sentenceId: $sentenceId) {
      id
      userId
      word
      active
    }
  }
`;

export const unsaveSentence = gql`
  mutation UnsaveSentence($userId: Int!, $sentenceId: Int!) {
    unsaveSentence(userId: $userId, sentenceId: $sentenceId) {
      id
      userId
      word
      active
    }
  }
`;
